module.exports = __webpack_public_path__ + "img/Logo-Group.576ade9f.svg";